/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 02.06.17.
 */

import ExtendableError from "extendable-error-class";

export class NotFoundException extends ExtendableError {
}

export class InternalErrorException extends ExtendableError {
}

/**
 * Thrown when there was attempt to execute unimplemented functionality
 */
export class NotImplementedException extends InternalErrorException {
}

/**
 * Thrown when in the UI were executed action not applicable to the current data.
 * This is internal error because UI should not present wrong or unsupported actions to the user.
 */
export class InvalidActionException extends InternalErrorException {
}

export class NotAuthorizedException extends ExtendableError {
}
